import React, { useCallback, useState } from "react";
import { useFetch } from "../../../../utils/hooks";
import "./UpdatePane.scss";
import { Spin, Button, message } from "antd";
import { ReactSVG } from "react-svg";
import { getPanesIcon, getStateSmallIcon } from "../../../../utils/images";
import { getStateColorMap } from "../../../../utils/utils";
import { getShipmentDetailsUpdate, createUpdate } from "../../../../services/shipments";
import { PlusOutlined } from '@ant-design/icons';
import UpdateForm from './UpdateForm';

const UpdateCard = ({ update }) => {
  return (
    <div className="UpdateCard">
      <div className="headline">
        <div className="headline__title">
          <div>
            <img src={getStateSmallIcon(update.state)} />
          </div>
          <div>
            {getStateColorMap(update.state).title}
          </div>
        </div>
        <div className="date">
          {update.date}
        </div>
      </div>

      <div className="message">
        {update.message}
      </div>
    </div>
  )
}

const UpdatePane = ({ shipment }) => {
  const [formVisible, setFormVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { data, loading: fetchLoading, refetch } = useFetch(useCallback(() => getShipmentDetailsUpdate(shipment.id), [shipment.id]))

  const updates = data?.updates || [];

  const handleCreateUpdate = async (values) => {
    setLoading(true);
    try {
      await createUpdate(shipment.id, values);
      message.success('Update created successfully');
      setFormVisible(false);
      refetch();
    } catch (error) {
      message.error(error.response?.data?.errors || error.response?.data?.message || 'Failed to create update');
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return <Spin size="large" className="spinner" />
  }

  return (
    <div className="UpdatePane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('updates')} />
        <div className="pane__title">Updates</div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setFormVisible(true)}
          className="pane__header-button"
        >
          Add Update
        </Button>
      </div>
      <div className="pane__wrapper">
        {updates?.map((update, index) => <UpdateCard key={index} update={update} />)}
      </div>

      <UpdateForm
        visible={formVisible}
        onCancel={() => setFormVisible(false)}
        onSubmit={handleCreateUpdate}
        loading={loading}
      />
    </div>
  )
}

export default UpdatePane;
